module.exports = __webpack_public_path__ + "img/description4.89038b56.jpg";